import api from 'Application/api/api';

const archiveInstruction = (id, cancelToken = null) =>
    api.post(`/education/instructions/${id}/archive`, { cancelToken });

export default archiveInstruction;
